import TextWithLateralImage from './TextWithLateralMedia'

export default TextWithLateralImage
